export default "__VITE_ASSET__ZgXVzKrD__"